/**
 * @exports fixAmountPrecision
 * @since 2.9.0
 */

/**
 * Converts a given number to a float.
 * In case the original amount has a decimal part (or using force decimal) the result will include a mantissa (a decimal point and digits).
 * @param  {Number}  [amount=0] The number to convert.
 * @param  {Number}  [precision=2] Amount of decimal points wanted at the result.
 * @param  {Boolean} [forceDecimal=false] Whether the decimal point should be forced or not.
 * @return {String}
 */
export const fixAmountPrecision = (amount = 0, precision = 2, forceDecimal = false) => (
    forceDecimal || amount > parseInt(amount, 10)
        ? amount.toFixed(precision)
        : amount.toString()
);
